import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import StandardTableVue from "@/components/table/StandardTable.vue";
import { getApiErrorData, getAppUpgradeData, getDeployData, getSettingOtherData, resolveError, saveAppUpgradeData } from "@/services/systemsetting";
export default {
  components: {
    StandardTableVue: StandardTableVue
  },
  i18n: require("../i18n-basucSettings"),
  data: function data() {
    return {
      dataList: [],
      dataLoading: true,
      appJsonData: null,
      showEdit: false,
      editForm: {
        type: 'Android',
        force: 0,
        content: {},
        versionCode: 0
      },
      editHideCodeForm: {
        android: 0,
        ios: 0
      },
      showEditHideCode: false,
      hideCodeJsonData: null,
      //
      saveAppUpgradeDataLoading: false //
    };
  },
  created: function created() {
    this.getData();
    this.getHideCodeData();
  },
  computed: {
    langMap: function langMap() {
      return {
        2: this.$t('deploy.appUpgrade.chinese'),
        3: this.$t('deploy.appUpgrade.japanese'),
        4: this.$t('deploy.appUpgrade.traditional')
      };
    }
  },
  methods: {
    onEditHideCode: function onEditHideCode() {
      this.editHideCodeForm = _.cloneDeep(this.hideCodeJsonData);
      this.showEditHideCode = true;
    },
    onEditHideCodeConfirm: function onEditHideCodeConfirm() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var jsonObj, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              jsonObj = _.cloneDeep(_this.editHideCodeForm);
              if (!_this.saveAppUpgradeDataLoading) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _this.saveAppUpgradeDataLoading = true;
              _context.p = 2;
              _context.n = 3;
              return saveAppUpgradeData({
                type: 81,
                configStr: jsonObj
              });
            case 3:
              res = _context.v;
              if (res.data.code == 200) {
                _this.$message.success(_this.$t('public.saveSuccessfully'));
                _this.showEditHideCode = false;
                _this.getHideCodeData();
              } else {
                _this.$message.error(res.data.message);
              }
            case 4:
              _context.p = 4;
              _this.saveAppUpgradeDataLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[2,, 4, 5]]);
      }))();
    },
    getHideCodeData: function getHideCodeData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, fixedStr, jsonObj, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return getSettingOtherData({
                type: 81
              });
            case 1:
              res = _context2.v;
              if (res.data.code == 200) {
                console.log('res.data', res.data.data);
                // 移除所有对象末尾的逗号（匹配 ", 任意空白 }" 并替换为 "}"）
                fixedStr = (res.data.data.settingContent || '').replace(/,(\s*})/g, '$1'); // 转换为 JSON 对象
                jsonObj = JSON.parse(fixedStr);
                _this2.hideCodeJsonData = jsonObj;
                console.log(jsonObj);
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }))();
    },
    onEditConfirm: function onEditConfirm() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var jsonObj, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              jsonObj = _.cloneDeep(_this3.appJsonData);
              jsonObj[_this3.editForm.type.toLowerCase()].force = _this3.editForm.force;
              jsonObj[_this3.editForm.type.toLowerCase()].content = _this3.editForm.content;
              jsonObj[_this3.editForm.type.toLowerCase()].versionCode = _this3.editForm.versionCode;
              _context3.n = 1;
              return saveAppUpgradeData({
                type: 80,
                configStr: jsonObj
              });
            case 1:
              res = _context3.v;
              if (res.data.code == 200) {
                _this3.$message.success(_this3.$t('public.saveSuccessfully'));
                _this3.showEdit = false;
                _this3.getData();
              } else {
                _this3.$message.error(res.data.message);
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    onEdit: function onEdit(type) {
      this.editForm = {
        type: 'Android',
        force: 0,
        content: {},
        versionCode: 0
      };
      this.editForm = _objectSpread({
        type: type === 'android' ? 'Android' : 'IOS'
      }, _.cloneDeep(this.appJsonData[type]));
      this.showEdit = true;
    },
    getData: function getData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, fixedStr, jsonObj, _t2;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.dataLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return getAppUpgradeData({
                type: 80
              });
            case 2:
              res = _context4.v;
              if (res.data.code == 200) {
                console.log('res.data', res.data.data);
                // 移除所有对象末尾的逗号（匹配 ", 任意空白 }" 并替换为 "}"）
                fixedStr = (res.data.data.settingContent || '').replace(/,(\s*})/g, '$1'); // 转换为 JSON 对象
                jsonObj = JSON.parse(fixedStr);
                _this4.appJsonData = jsonObj;
                console.log(jsonObj);
              }
              _this4.dataLoading = false;
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t2 = _context4.v;
              _this4.dataLoading = false;
            case 4:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 3]]);
      }))();
    }
  }
};